import type { NewMediaObject } from './store/newMediaStore';

import { twMerge } from 'tailwind-merge';

import Loader from '../components/Loader/Loader';

import { getTestProps } from './helpers';

/**
 * Get media data from upload
 */
export const getMediaData = (newMedia: NewMediaObject) => {
  const { media, state, error } = newMedia;
  const isLoaded = newMedia.state !== 'uploading';

  let card;
  if (['uploading', 'error'].includes(state)) {
    card = {
      id: media.id,
      fileName: 'name' in media ? media.name : '',
      extension: 'file',
      size: 'size' in media ? media.size : 0,
    };
  } else {
    card = media;
  }

  return { card, isLoaded, error };
};

/**
 * Get border for media card
 */
export const findBorderColor = (
  error?: string | string[],
  isLoaded?: boolean,
  isNew?: boolean,
) => {
  if (error) return 'border-2 border-red';
  if (!isNew) return '';
  if (!isLoaded) return 'border-2 border-slate-600';
  return 'border-2 border-lime-500';
};

/**
 * Get thumbnail for media card
 */
export const findThumbnail = (
  error?: string | string[],
  isLoaded?: boolean,
  small?: boolean,
  testId = '',
) => {
  if (error)
    return (
      <div className="h-full w-full flex items-center justify-center">
        <p
          className={twMerge(
            'p-2 max-h-full max-w-full text-red whitespace-normal overflow-hidden align-middle',
            small && 'text-xs',
          )}
          {...getTestProps(testId, 'card-uploaded-error')}
        >
          {error}
        </p>
      </div>
    );
  if (!isLoaded)
    return (
      <div
        className="h-full w-full flex items-center justify-center"
        {...getTestProps(testId, 'card-uploading')}
      >
        <Loader size={small ? 'small' : 'big'} type="spinner-grid" />
      </div>
    );
  return '';
};
